<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div v-if="!isLoading">
    <dl class="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
      <div v-for="item in stats" :key="item.name" class="px-4 py-5 sm:p-6">
        <dt class="text-base font-normal text-gray-900">
          {{ item.name }}
        </dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-indigo-600">
            {{ item.stat }}
          </div>

          <div v-if="item.stat !== 0 && item.change !== 0"
               :class="[item.changeType === 'increase' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800', 'inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0']">
            <ArrowUpIcon v-if="item.changeType === 'increase'"
                         class="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500"
                         aria-hidden="true"/>
            <ArrowDownIcon v-else class="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-red-500"
                           aria-hidden="true"/>
            <span class="sr-only"> {{
                item.changeType === 'increase' ? 'Increased' : 'Decreased'
              }} by </span>
            {{ Math.ceil(item.change) }}%
          </div>
        </dd>
      </div>
    </dl>
  </div>
  <div v-else>
    <v-loader class="mt-2"></v-loader>
  </div>
</template>

<script>
import {ArrowDownIcon, ArrowUpIcon} from '@heroicons/vue/24/solid'
import {mapActions, mapState} from "pinia";
import {useAnalytics} from "@/scripts/store/analytics";
import VLoader from "@/scripts/components/app/common/VLoader.vue";

export default {
  components: {
    VLoader,
    ArrowDownIcon,
    ArrowUpIcon,
  },

  props: {
    codeIdentifier: {
      default: null
    }
  },

  data() {
    return {
      stats: null,
      isLoading: false
    }
  },
  async mounted() {
    this.isLoading = true
    await this.loadShortSummary(this.codeIdentifier)
    this.stats = [
      {
        name: 'Сканирований сегодня',
        stat: this.shortSummary.today.current,
        previousStat: this.shortSummary.today.previous,
        change: this.shortSummary.today.previous > 0
          ? ((this.shortSummary.today.current - this.shortSummary.today.previous) / this.shortSummary.today.previous) * 100
          : 100,
        changeType: this.shortSummary.today.current >= this.shortSummary.today.previous ? 'increase' : 'decrease'
      },
      {
        name: 'Сканирований за 7 дней',
        stat: this.shortSummary.last7days.current,
        previousStat: this.shortSummary.last7days.previous,
        change: this.shortSummary.last7days.previous > 0
          ? ((this.shortSummary.last7days.current - this.shortSummary.last7days.previous) / this.shortSummary.last7days.previous) * 100
            : 100,
        changeType: this.shortSummary.last7days.current >= this.shortSummary.last7days.previous ? 'increase' : 'decrease'
      },
      {
        name: 'Сканирований за 30 дней',
        stat: this.shortSummary.last30days.current,
        previousStat: this.shortSummary.last30days.previous,
        change: this.shortSummary.last30days.previous > 0
          ? ((this.shortSummary.last30days.current - this.shortSummary.last30days.previous) / this.shortSummary.last30days.previous) * 100
            : 100,
        changeType: this.shortSummary.last30days.current >= this.shortSummary.last30days.previous ? 'increase' : 'decrease'
      },
    ]
    this.isLoading = false
  },
  computed: {
    ...mapState(useAnalytics, ['shortSummary'])
  },
  methods: {
    ...mapActions(useAnalytics, ['loadShortSummary'])
  }
}
</script>
